<template>
  <div class="qmulus-slider">
    <PrmSlider
      :model-value="props.modelValue"
      :min="props.min"
      :max="props.max"
      :step="props.step"
      :range="props.range"
      :disabled="props.disabled"
      :orientation="props.orientation"
      @update:model-value="emit('update:modelValue', $event as number)"
    />
    <template v-if="!isNullish(props.steps)">
      <div class="qmulus-slider__steps">
        <span
          v-for="step in props.steps"
          :key="step.index"
          class="qmulus-slider__step"
          :style="{
            '--position': `${step.position}%`,
          }"
          @click="emit('update:modelValue', step.index)"
        />
      </div>
    </template>
  </div>
</template>
<script setup lang="ts">
import PrmSlider from '@NitrexGroup/primevue/slider';

import {
  isNullish,
} from '../../utils/common.ts';

import {
  TQmulusSliderProps,
} from './qmulus-slider.ts';

const props = defineProps<TQmulusSliderProps>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: TQmulusSliderProps['modelValue']): void,
}>();

</script>

<style scoped lang="scss">
@use "@qmulus/primevue-theme/theme-variables.scss";
@use "@qmulus/ui/styles/z-index";

:deep(.p-slider .p-slider-handle) {
  z-index: z-index.$above2;
}

.qmulus-slider {
  position: relative;
  display: grid;
  background: theme-variables.$sliderBg;

  > * {
    grid-column: -1 / -1;
    grid-row: -1 / -1;
  }

  .p-slider {
    background: transparent;
  }
}

.qmulus-slider__steps {
  display: flex;
  width: 100%;

  > .qmulus-slider__step {
    position: absolute;
    top: 2px;
    left: var(--position, 0%);
    z-index: z-index.$above;
  }
}

.qmulus-slider__step {
  height: theme-variables.$sliderHandleHeight;
  width: theme-variables.$sliderHandleWidth;
  background: theme-variables.$sliderHandleBg;
  border: theme-variables.$sliderHandleBorder;
  border-radius: theme-variables.$sliderHandleBorderRadius;
  transition: theme-variables.$formElementTransition;
  outline-color: transparent;
  transform: translate(-50%, -50%);

  &:hover, &:focus {
    cursor: pointer;
    background: var(--primary-color);
  }
}
</style>
